module.exports = __webpack_public_path__ + "assets/black-down-arrow.d7be2b8f169ea3aa15a1e030a0fbdbf9.svg";